export { default } from './RedirectionHandler';
